// Using objects to emulate enums for JavaScript compatibility
export const GameState = {
    NOT_STARTED: 'NOT_STARTED',
    MAIN_MENU: 'MAIN_MENU',
    PLAYING: 'PLAYING',  PAUSED: 'PAUSED',
  GAME_OVER: 'GAME_OVER',
  LEVEL_COMPLETE: 'LEVEL_COMPLETE',
};

export const Tile = {
  WALL: 1,
  EMPTY: 0,
  FRAGMENT: 2,
  BLOOM: 3, // Power-up
  SPEED_BOOST: 4,
  SPIRIT_SLOWDOWN: 5,
};

export const Direction = {
  UP: 1,
  DOWN: 2,
  LEFT: 3,
  RIGHT: 4,
  NONE: 0,
};

export const SpiritMode = {
  CHASE: 'CHASE',
  SCATTER: 'SCATTER',
  VULNERABLE: 'VULNERABLE',
  EATEN: 'EATEN',
};
